import { Type } from 'class-transformer';

export class CurriculumManagerGradPlanDrilldownModel {
	id: number;
	title: string;
}

export function CurriculumManagerGradPlanDrilldownModel_ClassTransform_Type() {
	return CurriculumManagerGradPlanDrilldownModel;
}

export class CurriculumManagerGradPlanDrilldownResponseModel {
	@Type(CurriculumManagerGradPlanDrilldownModel_ClassTransform_Type)
	results: CurriculumManagerGradPlanDrilldownModel[];
	count: number;
}

export type CurriculumGradPlanDrilldownTypes = 'catalog' | 'course';
